import { useRouter } from 'next/router';

import useMutationHook from '@/hooks/useMutationHook';
import { API, URLs } from '@/api';
import { LocalStorage } from '@/utils/LocalStorage';

export const UpdateHeartCount = (answerId: number) => {
    const router = useRouter();

    const reloadPage = () => {
        if (router.query.isSearching)
            router.replace(
                { pathname: router.asPath, query: { isSearching: router.query.isSearching } },
                router.asPath,
            );
        else router.replace(router.asPath);
    };

    const { mutate: likeAnswer } = useMutationHook(
        ['like'],
        async () => {
            return await API.put(URLs.ina.like(answerId));
        },
        {
            onSuccess: () => {
                LocalStorage.setItem('InA-detail-y-position', `${window.scrollY}`);
                reloadPage();
            },
            onError: () => {},
        },
    );

    const { mutate: unlikeAnswer } = useMutationHook(
        ['unlike'],
        async () => {
            return await API.put(URLs.ina.unlike(answerId));
        },
        {
            onSuccess: () => {
                LocalStorage.setItem('InA-detail-y-position', `${window.scrollY}`);
                reloadPage();
            },
            onError: () => {},
        },
    );

    return { likeAnswer, unlikeAnswer };
};
